import mirrorProjectorConsole from "../assets/images/icons/mirror-projector-console.svg";
import MirrorActivityLayout from "../components/MirrorActivityLayout";
import { useTranslation } from "../components/Localization";

export default function MirrorProjectorTaskPage() {
  const { t } = useTranslation();
  return (
    <MirrorActivityLayout
      taskKey="projector"
      step={0}
      progressIcon="bottom"
      backTo="/tukorterem"
      nextTo="/tukorterem/video-bal"
    >
      <img
        className="mirror-console-graphic"
        src={mirrorProjectorConsole}
        alt={t("accessibility.projectorConsole")}
      />
    </MirrorActivityLayout>
  );
}
